import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@chakra-ui/react';
import { HelmetProvider } from 'react-helmet-async';

// Components
import Header from './components/Header';
import Footer from './components/Footer';

// Context Providers
import { LanguageProvider } from './contexts/LanguageContext';

// Pages
import Home from './pages/Home';
import About from './pages/About';
import Products from './pages/Products';
import Contact from './pages/Contact';

// Product Detail Pages
import CircuitTrainingProduct from './pages/CircuitTrainingProduct';
import ProblemBankProduct from './pages/ProblemBankProduct';
import AnalyticsDashboardProduct from './pages/AnalyticsDashboardProduct';
import StudentManagementProduct from './pages/StudentManagementProduct';

function App() {
  return (
    <HelmetProvider>
      <LanguageProvider>
        <Box minH="100vh" display="flex" flexDirection="column">
        <Header />
        
        <Box flex="1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/products/circuit-training" element={<CircuitTrainingProduct />} />
            <Route path="/products/problem-bank" element={<ProblemBankProduct />} />
            <Route path="/products/analytics-dashboard" element={<AnalyticsDashboardProduct />} />
            <Route path="/products/student-management" element={<StudentManagementProduct />} />
            <Route path="/contact" element={<Contact />} />
            
            {/* Catch-all route - redirect to home */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Box>
        
          <Footer />
        </Box>
      </LanguageProvider>
    </HelmetProvider>
  );
}

export default App;
